import type { WeatherLocation } from './api/useLocationAPI';

const defaultLocations: WeatherLocation[] = [
	{
		city: 'München',
		height: 518,
		label: '80331 München - Stadt München, Oberbayern',
		plz: '80331',
		value: '718',
	},

	{
		city: 'Nürnberg',
		height: 303,
		label: '90402 Nürnberg - Stadt Nürnberg, Mittelfranken',
		plz: '90402',
		value: '81',
	},

	{
		city: 'Ansbach',
		height: 401,
		label: '91522 Ansbach - Stadt Ansbach, Mittelfranken',
		plz: '91522',
		value: '1308',
	},

	{
		city: 'Augsburg',
		height: 487,
		label: '86150 Augsburg - Stadt Augsburg, Schwaben',
		plz: '86150',
		value: '270000',
	},

	{
		city: 'Bayreuth',
		height: 335,
		label: '95444 Bayreuth - Stadt Bayreuth, Oberfranken',
		plz: '95444',
		value: '1944',
	},

	{
		city: 'Landshut',
		height: 392,
		label: '84028 Landshut - Stadt Landshut, Niederbayern',
		plz: '84028',
		value: '1676',
	},

	{
		city: 'Regensburg',
		height: 345,
		label: '93047 Regensburg - Stadt Regensburg, Oberpfalz',
		plz: '93047',
		value: '988',
	},

	{
		city: 'Würzburg',
		height: 184,
		label: '97070 Würzburg - Stadt Würzburg, Unterfranken',
		plz: '97070',
		value: '2089',
	},
];

export function getRandomDefaultLocation(): WeatherLocation {
	const randomIndex = Math.floor(Math.random() * defaultLocations.length);

	return defaultLocations[randomIndex];
}
